import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { usePageContext } from 'src/hooks';
const BarContainer = styled.div `
  height: 20px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.rio.base.color.gray[theme.mode === 'light' ? 1400 : 300]};
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.rio.semantic.color.border.interactive};
`;
const BarFill = styled.div `
  height: 100%;
  width: ${(props) => props.percentage}%;
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${({ theme }) => theme.rio.base.color.orange[theme.mode === 'light' ? 75 : 800]};
`;
/**
 * Reviews histogram.
 */
export const ReviewsHistogram = ({ reviews }) => {
    const { bundle } = usePageContext();
    // If no reviews for product, then do not show the histogram
    if (!reviews || reviews.length === 0)
        return null;
    return (_jsx("div", { id: "reviews-histogram", children: _jsxs(Column, { spacingInset: "400 350 none 350", spacing: "350", "data-testid": "reviews-histogram", children: [_jsx(Text, { type: "h200", children: bundle.getMessage('customerReviews') }), _jsxs(Row, { spacing: "350", widths: ['fit', 'fill', 'fit'], children: [_jsx(Column, { spacing: "300", children: reviews.map((review) => (_jsx(Text, { type: "b200", children: review.label }, review.label))) }), _jsx(Column, { spacing: "300", children: reviews.map((review, index) => (_jsx(BarContainer, { children: _jsx(BarFill, { percentage: review.percentage }) }, index))) }), _jsx(Column, { spacing: "300", children: reviews.map((review, index) => (_jsxs(Text, { type: "b200", children: [review.percentage, "%"] }, index))) })] })] }) }));
};
